document.addEventListener('DOMContentLoaded', async () => {
  const config = window.collectionFiltersConfig || {};
  const sectionId = config.sectionId;
  const collectionHandle = config.collectionHandle;
  const collectionId = config.collectionId;
  const formattedCollectionId = `gid://shopify/Collection/${config.collectionId}`;
  const rawBrandModelData = config.brandModelData;
  const brandModelData = rawBrandModelData ? parseJsonSafe(decodeQuotes(rawBrandModelData))[0] : {};


  // Get the selected brand from URL parameters (for initialization only)
  function getSelectedBrandFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('filter.p.m.is_hidden.marca_dispozitiv') || '';
  }

  // Get the selected model from URL parameters (for initialization only)
  function getSelectedModelFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('filter.p.m.is_hidden.model_dispozitiv') || '';
  }

  // Show loading spinner
  function showLoadingSpinner(selectElement) {
    const optionsContainer = selectElement.querySelector('.custom-options');
    optionsContainer.innerHTML = '<li class="custom-option loading-spinner"> <div id="loadingSpinner">\n' +
      '      <span class="spinner"></span>\n' +
      '    </div></li>';
  }

  // Hide loading spinner
  function hideLoadingSpinner(selectElement) {
    const optionsContainer = selectElement.querySelector('.custom-options');
    const spinner = optionsContainer.querySelector('.loading-spinner');
    if (spinner) spinner.remove();
  }

  // Fetch or retrieve models from sessionStorage
  async function getModelsByBrand(selectedBrand) {
    var models = [];
    if(brandModelData && brandModelData[selectedBrand] ){
      models = brandModelData[selectedBrand];
    } else {
      models = await fetchModelsByBrand(collectionHandle, formattedCollectionId, selectedBrand);
    }
    return models;
  }

  // Initialize filters with brand data from Liquid-rendered DOM
  async function initializeFilters() {
    const brandSelect = document.getElementById(`brand-select-${sectionId}`);
    const modelSelect = document.getElementById(`model-select-${sectionId}`);
    const brandOptions = brandSelect.querySelector('.custom-options');
    const selectedBrand = getSelectedBrandFromURL();

    if (selectedBrand) {
      const selectedOption = brandOptions.querySelector(`.custom-option[data-value="${selectedBrand}"]`);
      if (selectedOption) {
        selectedOption.classList.add('selected');
        document.getElementById(`brand-select-value-${sectionId}`).textContent = selectedOption.textContent;
        document.getElementById(`brand-select-value-${sectionId}`).dataset.value = selectedBrand;
      }

      const selectedModel = getSelectedModelFromURL();
      if (selectedModel) {
        document.getElementById(`model-select-value-${sectionId}`).textContent = selectedModel;
        document.getElementById(`model-select-value-${sectionId}`).dataset.value = selectedModel;
      }

      await updateModels(selectedBrand); // Load models for URL brand on init
    } else {
      document.getElementById(`model-select-${sectionId}`).classList.add('disabled');
      document.getElementById(`submit-btn-filter-${sectionId}`).setAttribute('disabled', 'disabled');
    }
  }

  // Update model dropdown using getModelsByBrand
  async function updateModels(selectedBrand) {
    const modelSelect = document.getElementById(`model-select-${sectionId}`);
    const submitBtn = document.getElementById(`submit-btn-filter-${sectionId}`);
    const customOptions = modelSelect.querySelector('.custom-options');

    modelSelect.classList.remove('open');
    customOptions.innerHTML = '';
    showLoadingSpinner(modelSelect);

    modelSelect.classList.remove('disabled');
    submitBtn.removeAttribute('disabled');

    if (selectedBrand) {
      const models = await getModelsByBrand(selectedBrand); // Note: collectionId passed internally
      const filteredModels = models.map(([modelName]) => modelName);
      hideLoadingSpinner(modelSelect);

      filteredModels.forEach(model => {
        const li = document.createElement('li');
        li.className = 'custom-option';
        li.dataset.value = model;
        li.textContent = model;
        customOptions.appendChild(li);
      });

      const currentModelValue = document.getElementById(`model-select-value-${sectionId}`).dataset.value;
      if (currentModelValue && filteredModels.includes(currentModelValue)) {
        const selectedModelOption = customOptions.querySelector(`.custom-option[data-value="${currentModelValue}"]`);
        if (selectedModelOption) {
          selectedModelOption.classList.add('selected');
        }
      } else {
        document.getElementById(`model-select-value-${sectionId}`).textContent = config.modelText;
        document.getElementById(`model-select-value-${sectionId}`).dataset.value = '';
      }

      modelSelect.classList.remove('open');
      const trigger = modelSelect.querySelector('.custom-select-trigger');
      const searchInput = modelSelect.querySelector('.search-input');
      trigger.style.display = 'block';
      searchInput.style.display = 'none';
    }
  }

  // Handle dropdown interactions
  document.addEventListener('click', e => {
    const trigger = e.target.closest(`#brand-select-${sectionId} .custom-select-trigger, #model-select-${sectionId} .custom-select-trigger`);
    if (trigger) {
      const select = trigger.closest('.custom-select');
      const searchInput = select.querySelector('.search-input');
      closeAllSelects();
      select.classList.add('open');
      trigger.style.display = 'none';
      searchInput.style.display = 'block';
      searchInput.value = '';
      filterOptions(select, '');
      searchInput.focus();
      return;
    }

    const option = e.target.closest(`#brand-select-${sectionId} .custom-option, #model-select-${sectionId} .custom-option`);
    if (option) {
      const select = option.closest('.custom-select');
      const trigger = select.querySelector('.custom-select-trigger');
      const searchInput = select.querySelector('.search-input');

      trigger.textContent = option.textContent;
      trigger.dataset.value = option.dataset.value;
      trigger.style.display = 'block';
      searchInput.style.display = 'none';

      select.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
      option.classList.add('selected');
      select.classList.remove('open');

      if (select.id === `brand-select-${sectionId}`) {
        document.getElementById(`model-select-value-${sectionId}`).textContent = config.modelText;
        document.getElementById(`model-select-value-${sectionId}`).dataset.value = '';
        updateModels(option.dataset.value);
      }
    } else if (!e.target.classList.contains('search-input')) {
      closeAllSelects();
    }
  });

  // Search functionality
  document.querySelectorAll(`#brand-select-${sectionId} .search-input, #model-select-${sectionId} .search-input`).forEach(input => {
    input.addEventListener('input', e => {
      const select = e.target.closest('.custom-select');
      filterOptions(select, e.target.value.toLowerCase());
    });
  });

  function filterOptions(select, searchTerm) {
    select.querySelectorAll('.custom-option').forEach(option => {
      option.classList.toggle('hidden', !option.textContent.toLowerCase().includes(searchTerm));
    });
  }

  function closeAllSelects() {
    document.querySelectorAll(`#brand-select-${sectionId}, #model-select-${sectionId}`).forEach(select => {
      select.classList.remove('open');
      const trigger = select.querySelector('.custom-select-trigger');
      const searchInput = select.querySelector('.search-input');
      trigger.style.display = 'block';
      searchInput.style.display = 'none';
    });
  }

  // Form submission
  const form = document.getElementById(`collection-filters-form-${sectionId}`);
  if (form) {
    form.onsubmit = e => {
      e.preventDefault();
      const brand = document.getElementById(`brand-select-value-${sectionId}`).dataset.value;
      const model = document.getElementById(`model-select-value-${sectionId}`).dataset.value;
      let url = `${config.collectionUrl}?sort_by=title-ascending`;

      if (brand) url += `&filter.p.m.is_hidden.marca_dispozitiv=${encodeURIComponent(brand)}`;
      if (model && model !== config.modelText) url += `&filter.p.m.is_hidden.model_dispozitiv=${encodeURIComponent(model)}`;

      window.location.href = url;
    };
  }

  // Initialize
  await initializeFilters();
});